var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImagePlaceholder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.332 448H58.668C26.3047 448 0 421.695 0 389.332V122.668C0 90.3047 26.3047 64 58.668 64H453.332C485.695 64 512 90.3047 512 122.668V389.332C512 421.695 485.695 448 453.332 448V448ZM58.668 96C43.9688 96 32 107.969 32 122.668V389.332C32 404.031 43.9688 416 58.668 416H453.332C468.031 416 480 404.031 480 389.332V122.668C480 107.969 468.031 96 453.332 96H58.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.668 213.332C83.1367 213.332 64 194.199 64 170.668C64 147.137 83.1367 128 106.668 128C130.199 128 149.332 147.137 149.332 170.668C149.332 194.199 130.199 213.332 106.668 213.332ZM106.668 160C100.777 160 96 164.777 96 170.668C96 176.555 100.777 181.332 106.668 181.332C112.555 181.332 117.332 176.555 117.332 170.668C117.332 164.777 112.555 160 106.668 160Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 405.332C11.9023 405.332 7.80859 403.777 4.69141 400.641C-1.55859 394.391 -1.55859 384.258 4.69141 378.004L122.879 259.82C137.473 245.227 161.215 245.227 175.785 259.82L202.668 286.699L304.215 185.152C318.805 170.559 342.551 170.559 357.121 185.152L507.309 335.34C513.559 341.59 513.559 351.723 507.309 357.973C501.055 364.223 490.922 364.223 484.672 357.973L334.484 207.785C332.395 205.695 328.895 205.695 326.828 207.785L213.973 320.641C207.723 326.891 197.59 326.891 191.34 320.641L153.152 282.453C150.441 279.742 148.203 279.742 145.492 282.453L27.3086 400.641C24.1914 403.777 20.0977 405.332 16 405.332Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagePlaceholder);
export default __webpack_public_path__ + "static/media/image-placeholder.abba0bb6.svg";
export { ForwardRef as ReactComponent };